export default "/build/frontend/images/vendor/intl-tel-input/build/flags.png?007b2705c0a8f69dfdf6ea1bfa0341c9";